import AppFooter from './component'

export default AppFooter